<template>
  <div class="row">
   
    <div class="col-md-12 event_detail_ls">
      <div class="detail_wrapper">
        <div class="row">
          <div class="event_ls_label col-md-2">Title</div>
          <div class="col-md-10">{{getName()}}</div>
        </div>
      </div>

      <div class="detail_wrapper">
        <div class="row">
          <div class="event_ls_label col-md-2">Tag Link</div>
          <div class="col-md-10">{{getLink()}}</div>
        </div>
      </div>

      <div class="detail_wrapper">
        <div class="row">
          <div class="event_ls_label col-md-2">Description</div>
          <div class="col-md-10">{{getDescription()}}</div>
        </div>
      </div>
    
      </div>
      <div class="text-right mt-3 mr-5">
      <button type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-primary" @click="editData(tag)">Edit</button>
      <button type="button" class="mb-1 mt-1 me-1 btn btn-lg btn-danger" @click="removeBlog(tag)">Delete</button>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import _ from "lodash";
import constants from "@/config/constants";

export default {
  name: "TagsShow",
  data() {
    return {
      
    }
  },
  props: {
    tag: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    ...mapActions('TagsIndex', ['fetchData', 'setEditId']),
    ...mapActions('TagsSingle', ['setIsNew', 'destroyData','setItem','setIsEditing']),

    getName() {
      return _.get(this.tag, 'title', '');
    },
    getLink() {
      return _.get(this.tag, 'url', '');
    },
    getDescription() {
      return _.get(this.tag, 'description', '');
    },

    editData(item) {
      this.setItem(item);
      this.setIsEditing(true);
      //console.log(id)
      //this.setEditId(id);
      this.setIsNew(false);
    },
    removeBlog(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        confirmButtonColor: "#dd4b39",
        focusCancel: true,
        reverseButtons: true
      }).then(result => {
        if (result.isConfirmed) {
          this.destroyData(item._id)
              .then(() => {
                this.$flashMessage.show({
                        group: 'tags',
                        type: 'success',
                        title: 'Success',
                        text: 'Tag deleted successfully.'
                      });
                this.fetchData(this.$route.params.event_id);
              });
        }
      });
    },
  }
}
</script>


<style scoped lang="scss">
.setting_wrapper {
  float: right;

  a {
    color: #201e1eba;
    padding: 9px;
    margin-left: 5px;
    background: #c0cdd345;
    border-radius: 4px;
    border: 1px solid #80808054;
  }
}

.detail_wrapper {
  border-bottom: 1px solid #ccc;
  padding: 10px 0px;

  .event_ls_label {
    font-weight: bold;
  }
  .small-picture {
    max-width: 100px;
    width: 100%;
  }
}
</style>